import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Menu } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import { DeleteLicenseDialog } from "components/License/DeleteLicenseDialog"
import { type MouseEvent, useEffect, useState } from "react"
import authService from "services/authService"
import type { ILicense } from "types/licenseTypes"
import { UserRoles } from "types/userRoles"
import { CancelLicenseDialog } from "./CancelLicenseDialog"
import { UpdateLicenseDialog } from "./UpdateLicenseDialog"

type Props = {
  license: ILicense
}

export function LicenseListItemMenu({ license }: Props) {
  const [roles, setRoles] = useState<Array<string>>()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openMenu, setOpenMenu] = useState(false)
  const [enableMenuBtn, setEnableMenuBtn] = useState(false)

  const handleMenuClose = () => {
    setAnchorEl(null)
    setOpenMenu(false)
  }

  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setOpenMenu(true)
  }

  useEffect(() => {
    authService.getRolesAssignedToUser().then((roles) => {
      setRoles(roles)
      setEnableMenuBtn(
        (license.assignedUserId && license.licenseCanceled === false) ||
          (roles?.includes(UserRoles.HIAB_ADMIN) ?? false),
      )
    })
  }, [license.assignedUserId, license.licenseCanceled])

  return (
    <>
      <IconButton aria-label="edit" size="small" onClick={handleMenuOpen} disabled={!enableMenuBtn}>
        <MoreVertIcon></MoreVertIcon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {license.assignedUserId && license.licenseCanceled === false && (
          <CancelLicenseDialog license={license} />
        )}
        {roles?.includes(UserRoles.HIAB_ADMIN) && <DeleteLicenseDialog license={license} />}
        {roles?.includes(UserRoles.HIAB_ADMIN) && <UpdateLicenseDialog license={license} />}
      </Menu>
    </>
  )
}
